import React,{useState,Fragment,useContext,useEffect} from "react"
import _ from "lodash"
import {useGlobal, monthNames} from "./Reducer"
import Api, { TOKEN, BUILD } from "./Api";
import client_logo from "../../images/SoT-Here4TN-partners-logo.png"

 export default (props)=>
    {
 
 
        const [globalState, globalActions] = useGlobal();
        const [docList,setDocList]=useState([]);
        const [message,setMessage]=useState("");
      
       

     const    getDocList=()=>
        {
          Api.getAllPublishedDocuments().then(({RESULT,DATA})=>{

              setDocList(DATA);

          }).catch(err=>{
         
          });
        }
       

          useEffect(()=>{
            console.log(globalState.appData.id+"globalState.appData.id");
            if(globalState.appData.id!=null)
            {
              const month=globalState.appData.month;
              const year=globalState.appData.year;
              console.log("setting message to "+globalState.monthNames[month-1]+" "+year)
              setMessage(globalState.monthNames[month-1]+" "+year);
            }
            getDocList();
    

          },[ globalState.appData.id]);




        return (
          <div>
           
          <nav className="whitebg ogn_line">
      <div className="container">
      <div className="row">
       <div className="col-6">
          
        <img src="http://enews.g-bro.net/MonthlyeNews/assets/images/optum_logo.jpg"    className="img-fluid logo_right" alt="Optum Logo" />

         

          </div> 
       <div className="col-6 text-right">
           
 <a href="http://here4tn.com/" style={{border:0}} target="_blank">
 <img     
   src={client_logo}
  className="img-fluid logo_left" alt="Optum Client Logo" />
 </a>
          </div>

      </div>
      </div>
</nav>
<div className="whitetext
bggray">


    <nav className="navbar navbar-expand-md container ogn-nav">
      <button className="navbar-toggler collapsed" type="button" data-toggle="collapse" data-target="#mennavbar" aria-controls="mennavbar" aria-expanded="false" aria-label="Toggle navigation">
        <span className="navbar-toggler-icon"><em className="fa fa-bars" aria-hidden="true"></em></span>
      </button>
<div className="col-md-12 col-lg-6" ><div ></div> {message}</div>
      <div className="navbar-collapse collapse" id="mennavbar" >
        <ul className="navbar-nav ml-auto">
 
        <li className="nav-item   nav-list-item ">
        <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
         <span  >
          Archive</span>
        </a>
        <div className="dropdown-menu" style={{maxHeight:500,overflowY:'auto'}} aria-labelledby="navbarDropdown">
        {_.map(docList,(a,b)=>{
            let monthName=monthNames[a.month-1];
            monthName=_.startCase(monthName);

          return (<React.Fragment key={a.id+"::"+monthName+""+b}>
              <a className="dropdown-item" href={`/${BUILD}/public.html?accessToken=${TOKEN}&month=${monthName}_${a.year}`}>{monthName}-{a.year}</a>
         {b!=docList.length-1 && <div className="dropdown-divider"></div>}
         
          </React.Fragment>);
        })}
        </div>
      </li>
      <li    className="nav-item  nav-list-item">
               
               <a className="nav-link dropdown-toggle" href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" id="countact_us_btn">  
               <span  >  Contact</span></a>
   
               <div 
               className="dropdown-menu dropdown-menu-right displayed_nav"
                aria-labelledby="countact_us_btn" id="contact_here">
   
                     <span className="contact-title">Client Name:</span> <span className="contact-body" ng-show="showcontactinfo">
   
                     SoTN
                     </span>
   
                    
   
                     <br/> <span className="contact-title">
                 Access Code:
                     </span> <span className="contact-body" ng-show="showcontactinfo">
                     Here4TN
                      <br/> </span> <span className="contact-body">
                 Phone :
                     </span> <span className="contact-title" ng-show="showcontactinfo">
                     855-437-3486
                     </span>
   
   
   
               </div>
             </li>    


           
        </ul>
        </div>
    </nav>


</div>
</div>

        );
    };